import posts from "../data/posts";

export function formatDate(date) {
  return new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function Blog() {
  return (
    <section className="py-20">
      <div className="container-narrow">
        <h1 className="page-heading">Blog</h1>

        {posts.length === 0 ? (
          <p className="text-muted">No posts yet — check back soon.</p>
        ) : (
          <div className="divide-y divide-line">
            {posts.map((post) => (
              <a
                key={post.slug}
                href={`#/blog/${post.slug}`}
                className="block py-6 first:pt-0 group"
              >
                <time className="text-sm text-muted">{formatDate(post.date)}</time>
                <h2 className="font-medium mt-1 group-hover:text-muted transition-colors">
                  {post.title}
                </h2>
                {post.summary && (
                  <p className="text-sm text-muted mt-1">{post.summary}</p>
                )}
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
